import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspOrderListService {

  constructor(
    private http: HttpClient,
  ) { }

  orderList(userKey, garageKey,pageIndex: number = 0, pageSize: number = 150, magic,searchTerm?: string ){
    let paramData: any = {      
      userKey: userKey,
      garageKey: garageKey,
      source: "web",
      magicQuote :magic,
      searchTerm: searchTerm || ''
    };

     if (searchTerm && searchTerm.trim() !== '') {
    paramData.searchTerm = searchTerm;
    }
    const params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('size', pageSize.toString())
    
    // console.log('-----Get Order List-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/v2/order/getAllOrders`, paramData, { params });

  }

  timeLine(userKey,orderKey)
  {
        let param={ 
    };
    // console.log('-----Get timeLine details-----------');  
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/order/status/'+userKey+'/'+orderKey, param);
  }
  getorderdetails(orderKey){
    let param={ 
    };
    // console.log('-----Get Order details-----------');    
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/order/detail/'+orderKey, param);

  }
  getReorder(orderKey){
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/reOrder/' +orderKey);
  }
  getAdress(){
    let garageKey= localStorage.getItem('garageKey');
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}`+ '/garage/address/getAll/'+ garageKey);
  }
   getReturnDate(date){
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}`+ '/v2/order/sales/return/holiday-calendar?orderReceivedDate='+ date);
  }

  uploadReturnImages(orderId: string, item: string, reason: string, comments: string, count: number, files: File[],returnWindow: string, userKey: string, isReturn: boolean ) {
    const params = new HttpParams()
      .set('item', item)
      .set('reason', reason)
      .set('comments', comments)
      .set('count', count.toString())
      .set('returnWindow', returnWindow)
      .set('userKey', userKey)
      .set('isReturn', isReturn.toString());
      const formData = new FormData();
        files.forEach(file => {
          formData.append('file', file);  // Repeated "file" key is allowed
        });
  
    return this.http.put(`${GlobalVariable.BASE_API_URL_SPARES}`+'/v2/order/sales/return/'+orderId, formData, { params });
  }
    retuenStatus(salesReturnId, salesReturnItemId) {
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}`+'//v1/sales-order-return/detail/status/'+salesReturnId+'/'+salesReturnItemId);
  }
  createRegisterPart(body: any) {
    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}/v2/order/registerParts/create`,
      body
    );
  }
}